class post {
  constructor(usuario) {
    (this.usuario = usuario),
      (this.patentes = []),
      (this.id_jato = 0),
      (this.id_lb = 0),
      (this.marca = null),
      (this.estado = null),
      (this.modelo = null),
      (this.version = null),
      (this.combustible = 0),
      (this.agno = 0),
      (this.puertas = 0),
      (this.carroceria = ""),
      (this.transmision = "M");
  }
}

export { post };
